import { CreateNewSource } from "../Source/Create";
import { CreateNewThreatType } from "../ThreatType/Create";
import { CreateNewThreat } from "../Threat/Create";
import { CreateNewVulnerability } from "../Vulnerability/Create";
import { CreateNewAssetType, CreateNewAsset } from "../Asset/Create";
import { CreateNewReference } from "../Reference/Create";

const CommonSubmenuTabs = [
  { label: "Active", id: "Active" },
  { label: "Draft", id: "Draft" },
  { label: "Archive", id: "Archive" },
];
const AssetSubmenuTabs = [
  { label: "Asset Type", id: "type" },
  { label: "Asset", id: "asset" },
];
export const MainTabs = [
  { label: "Source", id: "S", subMenu: CommonSubmenuTabs },
  { label: "Threat Type", id: "Y", subMenu: CommonSubmenuTabs },
  { label: "Threat", id: "T", subMenu: CommonSubmenuTabs },
  { label: "Vulnerability", id: "V", subMenu: CommonSubmenuTabs },
  { label: "Asset", id: "A", subMenu: AssetSubmenuTabs },
  { label: "Rating", id: "R" },
  { label: "Reference", id: "Ref", subMenu: CommonSubmenuTabs },
];

export const getNewContent = (tab, submenu) => {
  if (tab === "S") {
    return <CreateNewSource />;
  } else if (tab === "Y") {
    return <CreateNewThreatType />;
  } else if (tab === "T") {
    return <CreateNewThreat />;
  } else if (tab === "V") {
    return <CreateNewVulnerability />;
  } else if (tab === "A") {
    return submenu === "asset" ? <CreateNewAsset /> : <CreateNewAssetType />;
  } else if (tab === "Ref") {
    return <CreateNewReference />;
  }
  return null;
};

export const getNewButtonLabel = (tab, submenu) => {
  if (tab === "S") {
    return "New Source";
  } else if (tab === "Y") {
    return "New Threat Type";
  } else if (tab === "T") {
    return "New Threat";
  } else if (tab === "V") {
    return "New Vulnerability";
  } else if (tab === "A") {
    return submenu === "asset" ? "New Asset" : "New Asset Type";
  } else if (tab === "R") {
    return "New Rating";
  } else if (tab === "Ref") {
    return "New Reference";
  }
  return "New Source";
};

export const getMenuItems = (tab, submenu, callback, selectedIds = []) => {
  const items = [];
  const menuItem = {
    icon: "UPLOAD",
    shouldCloseOnClick: true,
  };
  if (tab === "S") {
    menuItem.id = "import-source";
    menuItem.label = "Import Source";
    menuItem.variant = "CONTRAST";
    items.push(menuItem);
  } else if (tab === "Y") {
    menuItem.id = "import-threat-type";
    menuItem.label = "Import Threat Type";
    menuItem.variant = "CONTRAST";
    items.push(menuItem);
  } else if (tab === "T") {
    menuItem.id = "import-threat";
    menuItem.label = "Import Threat";
    menuItem.variant = "CONTRAST";
    items.push(menuItem);
    if (submenu === "Active" && selectedIds.length > 0) {
      items.push({
        id: "bulk-archive",
        label: "Archive",
        icon: "OPEN_FOLDER",
        variant: "CAUTION",
      });
    }

    if (submenu === "Draft" && selectedIds.length > 0) {
      items.push({
        id: "bulk-activate",
        label: "Activate",
        icon: "CHECK_CONFIRM",
        variant: "CONTRAST",
      });
    }
  } else if (tab === "V") {
    menuItem.id = "import-vulnerability";
    menuItem.label = "Import Vulnerability";
    menuItem.variant = "CONTRAST";
    items.push(menuItem);
    if (submenu === "Active" && selectedIds.length > 0) {
      items.push({
        id: "bulk-archive-vulnerability",
        label: "Archive",
        icon: "OPEN_FOLDER",
        variant: "CAUTION",
      });
    }

    if (submenu === "Draft" && selectedIds.length > 0) {
      items.push({
        id: "bulk-activate-vulnerability",
        label: "Activate",
        icon: "CHECK_CONFIRM",
        variant: "CONTRAST",
      });
    }
  } else if (tab === "A") {
    if (submenu === "asset") {
      menuItem.id = "import-asset";
      menuItem.label = "Import Asset";
      menuItem.variant = "CONTRAST";
      items.push(menuItem);
    } else {
      menuItem.id = "import-asset-type";
      menuItem.label = "Import Asset Type";
      menuItem.variant = "CONTRAST";
      items.push(menuItem);
    }
  } else if (tab === "Ref") {
    menuItem.id = "import-reference";
    menuItem.label = "Import Reference";
    menuItem.variant = "CONTRAST";
    items.push(menuItem);
  }
  return {
    items,
    onMenuClick: (item) => callback && callback(item),
  };
};
